export enum ReportTypesEnumKey {
  CA = 'ca',
  BRSR = 'brsr',
  STRATEGY = 'sr',
  GRI = 'gri',
  TCFD = 'tcfd',
  SASB = 'sasb',
  ESG_REPORTS = 'ESGREPORTS',
  CDP = 'cdp'
}
export enum ReportTypesEnumLabel {
  CA = 'Carbon Accounting Reports',
  ESG_REPORTS = 'ESG Reports',
  STRATEGY = 'Strategy Reports'
}

export const ESGCategories = [
  ReportTypesEnumKey.GRI,
  ReportTypesEnumKey.BRSR,
  ReportTypesEnumKey.TCFD,
  ReportTypesEnumKey.SASB,
  ReportTypesEnumKey.CDP
];
